export enum QuoteChangeState {
  Unchanged = 0,
  Changed = 1,
  BusinessRuleComplete = 2,
  UsedInQuote = 3,
}
